import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'

const StyledPage = ({ children }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        bgcolor: '#f5f7fa',
      }}>
      {/* Branding panel — desktop only */}
      {!isMobile && (
        <Box
          sx={{
            flex: 1,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            p: 8,
            color: '#fff',
            overflow: 'hidden',
            background:
              'radial-gradient(circle at 22% 28%, #3E4CB0 0%, #2A3690 42%, #1B2569 100%)',
          }}>
          {/* Decorative: flowing rings */}
          {[
            { top: -200, right: -200, size: 520, o: 0.18 },
            { top: -270, right: -150, size: 620, o: 0.12 },
            { bottom: -220, left: -220, size: 560, o: 0.16 },
            { bottom: -290, left: -170, size: 660, o: 0.1 },
          ].map((r, i) => (
            <Box
              key={`ring-${i}`}
              sx={{
                position: 'absolute',
                top: r.top,
                right: r.right,
                bottom: r.bottom,
                left: r.left,
                width: r.size,
                height: r.size,
                borderRadius: '50%',
                border: `1.5px solid rgba(140, 180, 255, ${r.o})`,
                zIndex: 0,
              }}
            />
          ))}

          {/* Decorative: glow blobs */}
          <Box
            sx={{
              position: 'absolute',
              top: -120,
              right: -100,
              width: 380,
              height: 380,
              borderRadius: '50%',
              background:
                'radial-gradient(circle, rgba(86, 168, 236, 0.55) 0%, rgba(43, 111, 208, 0) 70%)',
              zIndex: 0,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 24,
              right: 70,
              width: 130,
              height: 130,
              borderRadius: '50%',
              background:
                'radial-gradient(circle at 35% 35%, #5AB0F0 0%, #2C6FD0 100%)',
              opacity: 0.9,
              zIndex: 0,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: -150,
              left: -120,
              width: 420,
              height: 420,
              borderRadius: '50%',
              background:
                'radial-gradient(circle, rgba(70, 150, 230, 0.45) 0%, rgba(30, 90, 190, 0) 70%)',
              zIndex: 0,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 36,
              left: 48,
              width: 110,
              height: 110,
              borderRadius: '50%',
              background:
                'radial-gradient(circle at 35% 35%, #4FA3E0 0%, #2456B8 100%)',
              opacity: 0.85,
              zIndex: 0,
            }}
          />

          {/* Logo — top left */}
          <Box
            component="img"
            src="/prompta-cropped.png"
            alt="Prompta.AI"
            sx={{
              position: 'absolute',
              top: 40,
              left: 48,
              height: 40,
              width: 'auto',
              zIndex: 1,
            }}
          />

          {/* Headline */}
          <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'left', px: 4 }}>
            <Typography
              sx={{
                fontWeight: 800,
                textTransform: 'uppercase',
                letterSpacing: '0.01em',
                lineHeight: 1.3,
                fontSize: { md: '2.1rem', lg: '2.9rem' },
                textShadow: '0 2px 12px rgba(0, 0, 0, 0.25)',
              }}>
              <Box component="span" sx={{ color: '#5AB0F0' }}>Better</Box> Insights
              <br />
              <Box component="span" sx={{ color: '#5AB0F0' }}>Better</Box> Decisions
              <br />
              <Box component="span" sx={{ color: '#5AB0F0' }}>Better</Box> Outcomes
            </Typography>
          </Box>

          {/* Copyright — bottom center */}
          <Typography
            variant="body2"
            sx={{
              position: 'absolute',
              bottom: 40,
              left: 0,
              right: 0,
              textAlign: 'center',
              zIndex: 1,
              opacity: 0.6,
              fontSize: 12,
            }}>
            © 2026 Prompta AI Corp. All Rights Reserved
          </Typography>
        </Box>
      )}

      {/* Form panel */}
      <Box
        sx={{
          width: { xs: '100%', md: 520 },
          maxWidth: '100%',
          flexShrink: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: '#fff',
          px: { xs: 3, sm: 6 },
          overflowY: 'auto',
          boxShadow: isMobile ? 'none' : '-8px 0 30px rgba(0, 0, 0, 0.08)',
        }}>
        <Box sx={{ width: '100%', maxWidth: 400, mx: 'auto', my: 'auto', py: 5 }}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}

export default StyledPage
